import React from 'react'
import * as R from 'remeda'

import { getAppropriateChartInfo } from '../utils'

import { useBrandsData } from './useBrandsData'
import { useQuestionsData } from './useQuestionsData'

export const useMinMax = () => {
  const brandsData = useBrandsData()
  const questionsData = useQuestionsData()

  return React.useMemo(() => {
    const values = R.concat(
      brandsData.map(R.prop('estimatedPopulation')),
      questionsData.map(R.prop('estimatedPopulation')),
    )

    return getAppropriateChartInfo(values)
  }, [brandsData, questionsData])
}
